module.exports = __webpack_public_path__ + "static/media/manta_ray_thumb_even.0bee346d.webp";